(() => {
  const root = document.querySelector('.castelli-reviews');

  if (!root) {
    return;
  }

  const reviews = Array.from(root.querySelectorAll('[data-review]'));
  const filterButtons = Array.from(root.querySelectorAll('[data-review-filter]'));
  const countElement = root.querySelector('[data-review-count]');
  const loadMoreButton = root.querySelector('[data-review-load-more]');
  const initialCount = Number(root.dataset.initialCount || 10);
  const batchCount = Number(root.dataset.batchCount || 10);
  let activeFilter = 'all';
  let visibleLimit = initialCount;

  const pluralize = (count) => String(count) + ' ' + (count === 1 ? 'review' : 'reviews');

  root.classList.add('castelli-reviews--enhanced');

  reviews.forEach((review) => {
    const text = review.querySelector('[data-review-text]');
    const button = review.querySelector('[data-review-more]');

    if (!text || !button) {
      return;
    }

    text.classList.add('is-collapsed');

    if (text.scrollHeight > text.clientHeight + 2) {
      button.hidden = false;
      button.addEventListener('click', () => {
        const isCollapsed = text.classList.toggle('is-collapsed');
        button.textContent = isCollapsed ? 'Read more' : 'Show less';
      });
    } else {
      text.classList.remove('is-collapsed');
    }
  });

  const getMatchingReviews = () => reviews.filter((review) => activeFilter === 'all' || review.dataset.rating === activeFilter);

  const updateFilters = () => {
    filterButtons.forEach((button) => {
      const isActive = button.dataset.reviewFilter === activeFilter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const render = () => {
    const matchingReviews = getMatchingReviews();
    const visibleReviews = matchingReviews.slice(0, visibleLimit);
    const visibleSet = new Set(visibleReviews);
    const remaining = Math.max(matchingReviews.length - visibleReviews.length, 0);

    reviews.forEach((review) => {
      review.hidden = !visibleSet.has(review);
    });

    if (countElement) {
      countElement.textContent = pluralize(matchingReviews.length);
    }

    if (loadMoreButton) {
      loadMoreButton.hidden = remaining === 0;
      loadMoreButton.textContent = 'LOAD MORE (' + remaining + ' REMAINING)';
    }
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.reviewFilter || 'all';
      visibleLimit = initialCount;
      updateFilters();
      render();
    });
  });

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', () => {
      visibleLimit += batchCount;
      render();
    });
  }

  updateFilters();
  render();
})();
